import PageHeader from "../Components/pageHeader";
import { Button, Input, Grid, Form } from 'semantic-ui-react'
import { useState } from "react";
import { Errors } from "../Constants/errors";
import { displayErrors, displaySuccess } from '../Components/displayNotifications';
import { userResetPasswordRequest } from '../api/backend';
import { useSearchParams, setSearchParams } from "react-router-dom";

export default function AccountRecovery() {

    let [searchParams, setSearchParams] = useSearchParams();

    const [newPassword, setNewPassword] = useState('');
    const [recoveryKey, setRecoveryKey] = useState(searchParams.get("accountRecoveryToken") || "");
    const [invalid, setInvalid] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleSubmitLogin = async (e) => {

        e.preventDefault();
        setLoading(true);

        // let hasError = false;

        if (!e.target.checkValidity()) {
            setInvalid(true);
            setLoading(false);
            return null;
        }

        const request = await userResetPasswordRequest({
            password : newPassword,
            token: recoveryKey
        });

        if ([200, 201, 204].includes(request.status)) {
            displaySuccess("Your password has been changed");
            setLoading(false);
        } else {
            const response = await request.json();
            displayErrors(response);
        }

        setLoading(false);

    }

    return (
        <div className="ui container" style={{ marginTop: '2em' }}>
            <PageHeader
                title={"Account recovery"}
                icon={"key"}
            />
            <div style={{ marginTop: '2em' }}>
                <Form
                    onSubmit={handleSubmitLogin}
                    noValidate
                >
                    <Grid>
                        <Grid.Row columns={3} stretched>
                            <Grid.Column>
                                <Form.Field
                                    icon={'key'}
                                    control={Input}
                                    iconPosition={'left'}
                                    label={"Recovery Key"}
                                    value={recoveryKey}
                                    onChange={e => setRecoveryKey(e.target.value)}
                                    required
                                    error={invalid && !recoveryKey ? {
                                        content: Errors.required,
                                        pointing: 'below',
                                    } : false}
                                />
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row columns={3} stretched>
                            <Grid.Column>
                                <Form.Field
                                    icon={'lock'}
                                    control={Input}
                                    iconPosition={'left'}
                                    label={"New Password"}
                                    value={newPassword}
                                    onChange={e => setNewPassword(e.target.value)}
                                    required
                                    error={invalid && !newPassword ? {
                                        content: Errors.required,
                                        pointing: 'below',
                                    } : false}
                                />
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row columns={3} stretched>
                            <Grid.Column>
                                <Button
                                    color="orange"
                                    disabled={loading}
                                >
                                    Reset password
                                </Button>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row columns={3} stretched>
                            <Grid.Column>
                                <a href="/">Back to login</a>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Form>
            </div>
        </div>
    )
}